export const images = [
    { url: require('./img/lab.jpg') },
    { url: require('./img/speaker.jpg') },
    { url: require('./img/genshin_chest.jpg') },
    { url: require('./img/bike.jpg') },
    { url: require('./img/flying_ship1.jpg') },
    { url: require('./img/samurai_helmet.jpg') },
]